<template>
  <page-content></page-content>
</template>

<script>
/*analytics component from view directory by router*/

// components
import PageContent from './components/PageContent.vue';

export default {
  name: "Analytics",
  components: {
    PageContent
  }
};
</script>
